import {createAsyncThunk} from "@reduxjs/toolkit";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import axios from "axios";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
import {getLessonsTest} from "features/model/service/lessons/lessons-test/get-lessons-test/getLessonsTest";
import {setFormAddTestAC} from "app/popups-reducer";


export const putLessonTest = createAsyncThunk(
    "lessons/putLessonTest",
    async ({lessonsId, testId}: { lessonsId: string | undefined; testId: number }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);


            const response = await axios.put(
                `/api/lessons/${lessonsId}/tests`,
                {
                    testId: testId,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );


            if (response.data && response.data.success) {
                thunkAPI.dispatch(getLessonsTest({lessonsId}))
                thunkAPI.dispatch(setFormAddTestAC(false))
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
